class Series {

	constructor(type, name) {
		this.config = {
			type,
			name,
			dataAccessor: d => 0,
			curve: null,
			color: null,
			side: 'left',
			label: null,
			activePointEnabled: true,
			tooltipOrder: null,
			isValid: value => true,
			tooltipFormatter: value => value
		};

		this.associatedScale = null;
	}

	type(type) {
		this.config.type = type;
		return this;
	}

	data(data) {
		// Data accessor function - for example d => d.temperature.
		// Or for area series, return a length-2 array, with first item being the base
		// and the second item being the ceiling.
		this.config.dataAccessor = data;
		return this;
	}

	curve(curve) {
		this.config.curve = curve;
		return this;
	}

	color(color) {
		this.config.color = color;
		return this;
	}

	side(side) {
		this.config.side = side;
		return this;
	}

	label(label) {
		this.config.label = label;
		return this;
	}

	activePoint(isEnabled) {
		this.config.activePointEnabled = isEnabled;
		return this;
	}

	tooltipOrder(order) {
		this.config.tooltipOrder = order;
		return this;
	}

	isValid(isValid) {
		this.config.isValid = isValid;
		return this;
	}

	tooltipFormatter(formatter) {
		this.config.tooltipFormatter = formatter;
		return this;
	}

}

export function lineSeries(name) {
	return new Series('line', name);
}

export function areaSeries(name) {
	const s = new Series('area', name);

	// Replace default tooltip formatter
	s.config.tooltipFormatter = value => value[1];

	return s;
}

export function rangeBarSeries(name) {
	const s = new Series('range-bar', name);

	// Display the upper value by default, matching area series.
	s.config.tooltipFormatter = value => value[1];

	return s;
}

export function scatterSeries(name) {
	return new Series('scatter', name);
}



// WEBPACK FOOTER //
// ./utils/panelgraph/components/series.js